module.exports = __webpack_public_path__ + "img/wxpay-charge.bbb84f5f.svg";